<template>
  <div
    v-image-view="preview"
    class="easy-image"
    :style="{
      maxWidth: size + 'px',
      minWidth: size + 'px',
      maxHeight: size + 'px',
      minHeight: size + 'px',
      height: size + 'px'
    }"
    :errorx="imageError"
  >
    <ElImage ref="imageRef" :src="src || ''" fit="contain" @load="onLoad()">
      <template #placeholder>
        <div class="el-image__placeholder"> 加载... </div>
      </template>
      <template #error>
        <div v-if="size < 64" class="el-image__error">
          {{ src ? '加载' : '暂无' }}
          <br />
          {{ src ? '失败' : '图片' }}
        </div>
        <div v-else class="el-image__error">
          {{ src ? '加载失败' : '暂无图片' }}
        </div>
      </template>
    </ElImage>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { vImageView } from './widget/ImageViewer';

withDefaults(
  defineProps<{
    src?: string | null;
    preview?: boolean; // 鼠标移上去时，是否显示放大图
    size?: number; // 大小, 默认64x64
  }>(),
  {
    src: null,
    preview: true,
    size: 64
  }
);

const imageRef = ref();
const imageError = ref();
// 404错误时检测不到
function onLoad() {
  const img = imageRef.value?.$el?.querySelector('img');
  if (!img) return;
  imageError.value = img.naturalWidth > 1 ? undefined : '';
}
</script>

<style lang="scss" scoped>
.easy-image {
  // 放在ag-grid中使得垂直居中
  &:only-child {
    display: block;
  }
  padding: 0 !important;

  & > .el-image {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    height: 100%;

    img {
      display: block;
      object-fit: contain;
    }
  }

  overflow: visible;
}

.easy-image[errorx] {
  background: var(--el-fill-color-light);

  & > .el-image::before {
    content: '加载失败';
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: var(--el-text-color-placeholder);
  }
}

.el-image__placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-placeholder);
  vertical-align: middle;
}
</style>
